import React from "react";
import {
  PauseIcon,
  Trash,
  ExportResult,
} from "../../assets/icon";

const RestartIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.5" />
    <path d="M10 8.5L16 12L10 15.5V8.5Z" fill="currentColor" />
  </svg>
);

const ManageCampaignToolbar = ({
  isHold,
  isArchived,
  statusKey,
  statusLoading,
  onRestart,
  onHold,
  onArchive,
  onExport,
}) => {
  const showRestart = statusKey === "hold" && !isArchived;
  const showHold = statusKey === "active" && !isArchived && !isHold;
  const showArchive =
    (statusKey === "active" || statusKey === "hold" || statusKey === "draft") &&
    !isArchived;
  const showExport = !isArchived;

  return (
    <div className="d-flex gap-3">
      {showRestart && (
        <div
          className="btn d-flex align-items-center gap-2 custom-button fs-16"
          onClick={onRestart}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              onRestart();
            }
          }}
        >
          <RestartIcon />
          Restart
        </div>
      )}
      {showHold && (
        <div
          className="btn d-flex align-items-center gap-2 custom-button fs-16"
          onClick={onHold}
          disabled={statusLoading}
        >
          <PauseIcon />
          Hold
        </div>
      )}
      {showArchive && (
        <div
          className="btn d-flex align-items-center gap-2 custom-button fs-16"
          onClick={onArchive}
          disabled={statusLoading}
        >
          <Trash color={"#162C4E"} />
          Archive
        </div>
      )}
      {showExport && (
        <div
          className="btn d-flex align-items-center gap-2 custom-button fs-16"
          onClick={onExport}
        >
          <ExportResult color={"#162C4E"} />
          Export Result
        </div>
      )}
    </div>
  );
};

export default ManageCampaignToolbar;
